import script from "./vertical_navigator.vue?vue&type=script&setup=true&lang=ts"
export * from "./vertical_navigator.vue?vue&type=script&setup=true&lang=ts"

import "./vertical_navigator.vue?vue&type=style&index=0&id=d308315e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d308315e"]])

export default __exports__